import { FC } from "react";

import { BulkGridSelectionControl } from "./bulk-grid-selection";

interface IRidesSelectAllCheckboxProps {
  enableSelectRows?: boolean;
  enableSelectionMenu?: boolean;
}

export const RidesSelectAllCheckbox: FC<IRidesSelectAllCheckboxProps> = ({
  enableSelectRows = true,
  enableSelectionMenu = true,
}) => {
  return (
    <BulkGridSelectionControl
      enableSelectRows={enableSelectRows}
      enableSelectionMenu={enableSelectionMenu}
    />
  );
};
